/* nc-lp-newsletter.js — self-contained newsletter signup for the campaign
 * landing pages (sections/nc-lp-newsletter.liquid).
 *
 * Deliberately independent of handleAddToNewsletterInFooter.js: that global
 * handler subscribes using a shared, debounced module-level `email` variable
 * instead of the submitted form's input, so it silently fails to save on
 * autofill / fast submit. This handler reads input.value directly at submit,
 * POSTs to the same subscribe endpoint, and pushes the same `subscribe_nwl`
 * dataLayer event on success. It binds only forms marked [data-nc-newsletter],
 * so it never double-binds the footer/feature-content forms.
 */
(function () {
  'use strict';

  if (window.__ncLpNewsletterLoaded) return;
  window.__ncLpNewsletterLoaded = true;

  var ENDPOINT = 'https://natu.care/api/subscribe-newsletter';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var MSG = {
    invalid: 'wpisany email jest niepoprawny',
    taken: 'wpisany email jest już wykorzystany',
    success: 'wysłaliśmy zniżkę',
    error: 'coś poszło nie tak — spróbuj ponownie'
  };

  function setStatus(form, statusEl, text, state) {
    form.classList.remove('is-success', 'is-error', 'is-invalid', 'is-taken');
    if (state) form.classList.add('is-' + state);
    if (statusEl) statusEl.textContent = text || '';
  }

  function initForm(form) {
    if (form.__ncLpNlBound) return;
    form.__ncLpNlBound = true;

    var input = form.querySelector('[data-nc-newsletter-input]');
    var button = form.querySelector('[data-nc-newsletter-submit]');
    var statusEl = form.querySelector('[data-nc-newsletter-status]');
    if (!input || !button) return;

    var tags = form.getAttribute('data-nc-newsletter-tags') || 'newsletter';
    var loading = false;

    // Clear any prior message as soon as the user edits the field again.
    input.addEventListener('input', function () {
      if (loading) return;
      setStatus(form, statusEl, '', null);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (loading) return;

      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        setStatus(form, statusEl, MSG.invalid, 'invalid');
        input.focus();
        return;
      }

      loading = true;
      form.classList.add('is-loading');
      button.disabled = true;
      setStatus(form, statusEl, '', null);

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, tags: tags })
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; });
        })
        .then(function (data) {
          if (data && data.errorCode === 'EMAIL_ALREADY_TAKEN') {
            setStatus(form, statusEl, MSG.taken, 'taken');
          } else if (data && data.errorCode) {
            setStatus(form, statusEl, MSG.error, 'error');
          } else {
            setStatus(form, statusEl, MSG.success, 'success');
            input.value = '';
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'subscribe_nwl' });
          }
        })
        .catch(function () {
          setStatus(form, statusEl, MSG.error, 'error');
        })
        .then(function () {
          loading = false;
          form.classList.remove('is-loading');
          button.disabled = false;
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-nc-newsletter]');
    Array.prototype.forEach.call(forms, initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
